module.exports = __webpack_public_path__ + "img/CS-Profi13_Overview.ba0217cb.jpg";